import React, { useRef, useState, useEffect } from "react";
import { Link } from "gatsby";
import cx from "clsx";

import LogoImg from "@/images/shared/elco-badge-1a.png";

import globalStyles from "@/styles/global.module.scss";
import styles from "./logo.module.scss";

const handleClick = () => window.scrollTo(0, 0);

const Logo = props => {
  const { hidden, src, className, isDesktop, windowHeight } = props;

  const prevScrollY = useRef(0);
  const [scrollingDown, setScrollingDown] = useState(false);

  useEffect(() => {
    if (!isDesktop) return;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (
        prevScrollY.current < currentScrollY &&
        !scrollingDown &&
        currentScrollY > windowHeight * 0.8
      ) {
        setScrollingDown(true);
      }
      if (prevScrollY.current > currentScrollY && scrollingDown) {
        setScrollingDown(false);
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollingDown, isDesktop]); // eslint-disable-line

  return (
    <div
      className={cx(
        styles.container,
        scrollingDown && styles.isSmall,
        className,
        hidden && styles.hidden
      )}
    >
      <Link to="/" onClick={handleClick} className={styles.link}>
        <img className={globalStyles.image} src={src} alt="Elco" />
      </Link>
    </div>
  );
};

Logo.defaultProps = {
  src: LogoImg
};

export default Logo;
